<script setup lang="ts">
  import type { SegmentedOption } from '~/types/apply'
  import { useField } from 'vee-validate'

  // Pill segmented control bound to a vee-validate field. Used for the
  // experience chips (0-3 / 3-5 / 5-10 / +10) and the Non/Oui[/NSPP] toggles
  // (fonctionnaire, candidature interne, RQTH).
  const props = withDefaults(
    defineProps<{
      name: string
      label?: string
      options: SegmentedOption[]
      value?: SegmentedOption['value']
    }>(),
    { label: '', value: false }
  )

  const theme = useCareerTheme()

  const { value: fieldValue } = useField<SegmentedOption['value']>(() => props.name)
  watch(
    () => props.value,
    v => (fieldValue.value = v),
    { immediate: true }
  )
</script>

<template>
  <div>
    <label class="mb-1 block font-bold" v-if="label">{{ label }}</label>
    <div class="inline-flex flex-wrap gap-2">
      <button
        v-for="(option, i) in options"
        :key="i"
        type="button"
        :class="[
          'rounded px-4 py-1.5 text-sm duration-200',
          fieldValue === option.value
            ? theme.primary
              ? 'text-white'
              : 'bg-viking-400 text-white'
            : 'bg-zinc-100 text-zinc-600 hover:bg-zinc-200'
        ]"
        :style="fieldValue === option.value && theme.primary ? { backgroundColor: theme.primary } : undefined"
        @click="fieldValue = option.value"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>
